export class EuroCents {
  public readonly cents: number
  constructor(cents: number) {
    this.cents = cents
  }

  public get euros(): number {
    return this.cents / 100
  }

  public get euroCentValue(): { euros: string; cents: string } {
    const [euros, cents] = this.euros.toFixed(2).split('.')
    return {
      euros,
      cents,
    }
  }

  public add = (x: EuroCents): EuroCents => {
    return new EuroCents(this.cents + x.cents)
  }

  public multiply = (x: number): EuroCents => {
    return new EuroCents(this.cents * x)
  }

  public static zero = (): EuroCents => new EuroCents(0)
  public static fromCents = (cents: number): EuroCents => new EuroCents(cents)
  public static fromEuros = (euros: number): EuroCents => new EuroCents(euros * 100)

  public format = (): string => `${this.euros.toFixed(2).replace('.', ',')} €`
  public formatApproximate = (): string => `~${this.format()}`

  public static sumOf = (xs: EuroCents[]) => xs.reduce((p, c) => p.add(c), EuroCents.zero())
}
